import React from 'react';
import PropTypes from 'prop-types';
import { GeneralSelect } from 'sharedComponents/GeneralSelect';
import { LimitTypeOptions } from './constants';
import Option from './Option';
import NotificationBanner from './NotificationBanner';
import Limit from './Limit';
import { MultiPointSlider } from 'sharedComponents/Slider';
import { getMinValue, getSliderValues } from './helper';
import PersonalLimit from './PersonalLimit';

const LimitApplicable = ({
    timeSeries,
    defaultLimits,
    actions,
    translate,
    checkIsSmseAsset,
    asset,
    showMaxLimitMessage,
    setShowMaxLimitMessage,
    ...props
}) => {
    const { model } = props;
    const { limitTypeChange, setExpandedSignals } = actions;
    const handleLimitTypeChange = (value, item) => {
        limitTypeChange(item, value);
    };
    return (
        <>
            <div className='content-container' id={timeSeries?.uniqId}>
                {defaultLimits?.length === 0 &&
                    <div className='limit-type-container'>
                        <div className='limit-type'>
                            <GeneralSelect
                                options={LimitTypeOptions}
                                getOptionLabel={option => option.name}
                                getOptionValue={option => option.value}
                                components={{ Option }}
                                onChange={(e) => {
                                    handleLimitTypeChange(e.value, timeSeries);
                                }}
                                placeholder={translate('ABB.Powertrain.Frontend.limitTypePlaceholder')}
                            />
                        </div>
                        <div className='no-limits'>
                            {translate('ABB.Powertrain.Frontend.noLimitsMessage')}
                        </div>
                    </div>
                }
                {defaultLimits?.length >= 4 && showMaxLimitMessage && <div className='mx-4 my-3'> <NotificationBanner
                    message={translate('ABB.Powertrain.Frontend.personalLimitsMessage')}
                    onClose={() => { setShowMaxLimitMessage(false); }}
                /></div>}
                {defaultLimits?.length > 0 &&
                    defaultLimits?.map(limit =>
                        <Limit key={limit?.uniqId} item={limit} timeSeries={timeSeries} kpiList={model?.limitKPI?.kpiList} asset={asset} checkIsSmseAsset={checkIsSmseAsset} />
                    )
                }
                {defaultLimits?.length > 0 &&
                    <div className='limit-slider-container'>
                        <MultiPointSlider
                            uniqId={timeSeries?.uniqId}
                            showPointer
                            showMinMax={timeSeries?.minValue !== null}
                            min={getMinValue(timeSeries, 'min')}
                            max={getMinValue(timeSeries, 'max')}
                            value={getSliderValues(defaultLimits)}
                        />
                    </div>
                }
            </div>
            <PersonalLimit
                {...props}
                timeSeries={timeSeries}
                isExpanded={props.isExpanded}
                expandedItem={props.expandedItem}
                setExpandedItem={setExpandedSignals}
                setIsExpanded={props.setIsExpanded}
                userLimits={props.userLimits}
                checkIsSmseAsset={props.checkIsSmseAsset}
                handleExpandSignal={props.handleExpandSignal}
                expandItemName={props.expandItemName}
                setContextMenuId={props.setContextMenuId} />
        </>
    );
};

LimitApplicable.propTypes = {
    timeSeries: PropTypes.shape({
        uniqId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        minValue: PropTypes.number,
        maxValue: PropTypes.number,
    }),
    defaultLimits: PropTypes.array,
    actions: PropTypes.shape({
        limitTypeChange: PropTypes.func,
        setExpandedSignals: PropTypes.func,
    }),
    translate: PropTypes.func,
    checkIsSmseAsset: PropTypes.func,
    asset: PropTypes.object,
    showMaxLimitMessage: PropTypes.bool,
    setShowMaxLimitMessage: PropTypes.func,
    model: PropTypes.shape({
        limitKPI: PropTypes.shape({
            kpiList: PropTypes.array,
        }),
        // add other model properties as needed
    }),
    isExpanded: PropTypes.bool,
    expandedItem: PropTypes.any,
    setIsExpanded: PropTypes.func,
    userLimits: PropTypes.array,
    handleExpandSignal: PropTypes.func,
    expandItemName: PropTypes.string,
    setContextMenuId: PropTypes.func,
};

export default React.memo(LimitApplicable);
